import Vue from 'vue'
import Vuex from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { generateMenu } from '@/plugins/roleMenu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errorCode: [],
    token: '',
    identity: undefined,
    permApi: undefined,
    roles: undefined,
    customerMap: {},
    platTypeList: JSON.parse(localStorage.getItem('platTypeList') || '[]'),
    platTypeLevel: JSON.parse(localStorage.getItem('platTypeLevel') || '[]'),
    //  1 用户 2商户
    userTypeList: [{
      id: 1,
      name: '用户',
      label: 'user'
    }, {
      id: 2,
      name: '商户',
      label: 'mercacc'
    }
    // , {
    //   id: 3,
    //   name: '通用',
    //   label: 'common'
    // }
    ],
    componentTypeList: sessionStorage.getItem('componentTypeList') ? JSON.parse(sessionStorage.getItem('componentTypeList')) : null,
    iconDirectoryList: {
      mobile: [{
        id: 1,
        name: 'seachBar',
        label: '搜索栏'
      }, {
        id: 2,
        name: 'appView',
        label: '应用栏'
      }, {
        id: 3,
        name: 'codeBar',
        label: '快捷方式栏'
      }, {
        id: 4,
        name: 'funView',
        label: '功能栏'
      }, {
        id: 5,
        name: 'financeView',
        label: '金融栏'
      }],
      pc: [{
        id: 1,
        name: 'seachBarPC',
        label: '搜索栏'
      }, {
        id: 2,
        name: 'appView',
        label: '应用栏'
      }],
      selfService: [{
        id: 1,
        name: 'appSelfView',
        label: '应用栏'
      }, {
        id: 2,
        name: 'appView',
        label: '全部应用栏'
      }]
    },
    iconModeList: {
      mobile: [{
        code: 'checked',
        name: '选中状态'
      }, {
        code: 'white',
        name: '正常模式'
      }, {
        code: 'black',
        name: '深色模式'
      }],
      pc: [{
        code: 'white',
        name: '图标'
      }],
      selfService: [
        {
          code: 'white',
          name: '图标'
        }
      ]
    }
  },
  getters: {
    logged: state => {
      return !!state.token
    },
    menuItems: state => {
      if (!state.identity || !state.identity.roles) {
        return []
      }
      const codeList = state.identity.roles.map(r => r.code)
      return generateMenu(codeList)
    }
  },
  mutations: {
    retrieveToken (state) {
      // 取回token
      state.token = localStorage.getItem('token')
    },
    updateToken (state, token) {
      // 更新token
      state.token = token
      localStorage.setItem('token', token)
      if (!token) {
        sessionStorage.clear()
      }
    },
    setIdentity (state, payload) {
      state.identity = payload
    },
    updateIdentity (state, payload) {
      if (state.identity) {
        state.identity[payload.key] = payload.value
      }
    },
    setErrorCode (state, payload) {
      if (state.errorCode.length === 0) {
        state.errorCode.push(...payload)
      } else {
        state.errorCode = payload
      }
    },
    setPermApi (state, payload) {
      state.permApi = payload.reduce((acc, cur) => {
        acc[cur.key] = cur
        return acc
      }, {})
    },
    setRoles (state, payload) {
      state.roles = payload
    },
    addCustomerMap (state, payload) {
      state.customerMap[payload.id] = payload
    },
    setPlatType (state, payload) {
      state.platTypeList = payload.arr
      state.platTypeLevel = payload.list
      console.log('setPlatType', payload)
      localStorage.setItem('platTypeList', JSON.stringify(payload.arr)) // 平台类型父子级
      localStorage.setItem('platTypeLevel', JSON.stringify(payload.list)) // 平台类型同级
    },
    setComponentType (state, payload) {
      console.log('setComponentType', payload)
      state.componentTypeList = payload
      sessionStorage.setItem('componentTypeList', JSON.stringify(payload))
    }
  },
  actions: {
    getIdentity ({ commit }) {
      const request = buildAxios()
      request.get('auth/identity')
        .then(res => {
          commit('setIdentity', res.data.data)
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getErrorCode ({ commit }) {
      // 从 localStorage 读取错误代码
      const codeStr = localStorage.getItem('errorCode')
      try {
        const codeFromLs = JSON.parse(codeStr)
        if (Array.isArray(codeFromLs)) {
          commit('setErrorCode', codeFromLs)
        }
      } catch (e) {
        console.error('ErrorCode 解析失败')
      }

      // 从服务器请求新的错误代码表
      const request = buildAxios()
      request.get('errorCode/code.json')
        .then(res => {
          commit('setErrorCode', res.data.data)
          localStorage.setItem('errorCode', JSON.stringify(res.data.data))
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getPermApi ({ commit }) {
      const request = buildAxios()
      request.get('api/getAll')
        .then(res => {
          commit('setPermApi', res.data.data)
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getRoles ({ commit }) {
      const request = buildAxios()
      request.get('role/getAll')
        .then(res => {
          commit('setRoles', res.data.data)
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getPlatType ({ commit }) {
      const request = buildAxios()
      request.get('basePlatInfo/list').then(res => {
        const list = res.data.data
        const arr = []
        list.forEach(element => {
          // if (element.code === 'pc' || element.code === 'selfService') {
          //   element.routingParameters = 1
          // } else {
          //   element.routingParameters = 0
          // }
          if (!element.parentCode) {
            const children = list.filter((item) => {
              return item.parentCode === element.code
            })
            const obj = { ...element, ...{ children: children } }
            arr.push(obj)
          }
        })
        list.forEach((element) => {
          if (element.parentCode) {
            console.log(element)
            const index = list.findIndex(
              (item) => item.code === element.parentCode
            )
            if (index >= 0) list.splice(index, 1)
          }
        })
        console.log('getPlatType', arr)
        commit('setPlatType', { arr, list })
      }).catch(reason => {
        console.error(reason)
      })
    }

  },
  modules: {}
})
